const announcement = {
    getall: 'Announcement/getall',
    add: 'Announcement/add',
    remove: 'Announcement/remove',
    getlist: 'Announcement/getlist',
    get: 'Announcement/get',
    update: 'Announcement/update',
    getUserMessages: 'Announcement/get-by-userid',
}
export default announcement
